import React from 'react'

function EarthIcon () {
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
      >
        <g
          id='Group_12545'
          data-name='Group 12545'
          transform='translate(-40 -816)'
        >
          <rect
            id='Rectangle_7223'
            data-name='Rectangle 7223'
            width='52'
            height='52'
            rx='16'
            transform='translate(40 816)'
            fill='#1a7222'
          />
          <g
            id='Group_12445'
            data-name='Group 12445'
            transform='translate(53 830)'
          >
            <path
              id='Path_16282'
              data-name='Path 16282'
              d='M26.827,21.406c-.328-2.755-1.4-2.986-2.526-3.6.194-.5.786-1.076.788-1.626,0-.276-.215-.438-.264-.637a4.324,4.324,0,0,0-.179-.937,2.023,2.023,0,0,0-3.2-.252c-.383.488-.2.668-.311,1.11-.064.252-.276.432-.282.715-.013.621.585,1.074.785,1.628l-.8.455a7.191,7.191,0,0,0-1.422-4.567H21.5c.613-.794.1-2.417-.666-2.987-.244-.181-1.6-.705-1.6-.817.088-.417.553-.811.648-1.166a4.948,4.948,0,0,0-.338-2.1,2.017,2.017,0,0,0-3.421.171c-.091.248-.227.817-.309,1.112-.215.773.45,1.347.764,1.985a5.8,5.8,0,0,1-1.526.7c-.183.085-.342.306-.474.344-.256.074-.514-.09-.784-.089-.2,0-.4.127-.615.115-.36-.019-.381-.275-.622-.4s-1.3-.479-1.348-.684l.708-1.618c-.22-.478-.226-1.175-.426-1.606A2.029,2.029,0,0,0,8.1,6.689a6.28,6.28,0,0,0-.347,1.872c.072.457.57.856.689,1.328-.52.488-1.383.518-1.878,1a2.555,2.555,0,0,0-.392,2.805H8.152a7.8,7.8,0,0,1-.627,1.149,8.029,8.029,0,0,0-.694,3.418l-.8-.455c.2-.554.8-1.007.785-1.628-.006-.283-.218-.463-.282-.715-.121-.475.078-.661-.358-1.164-.845-.974-2.876-.773-3.233.529-.069.253-.041.483-.1.715-.047.2-.249.325-.245.619.01.687.657,1.141.78,1.792-1.316.431-2.4.814-2.541,2.382-.02.221-.059,1.273.258,1.273H7.9a7.106,7.106,0,0,0,7.444,3.08,16.932,16.932,0,0,1,1.637-.5l4.063,5.994a1.693,1.693,0,0,0,2.82-1.805,3.961,3.961,0,0,0-.59-.831c-1.311-1.676-2.927-3.212-4.208-4.925l.6-.921,6.711-.089Z'
              transform='translate(-0.827 -5.754)'
              fill='none'
            />
            <g
              id='world_globe_public_24dp_000000_FILL0_wght200_GRAD200_opsz24'
              data-name='world, globe, public_24dp_000000_FILL0_wght200_GRAD200_opsz24'
              transform='translate(-1 -2)'
            >
              <path
                id='public_24dp_000000_FILL0_wght200_GRAD200_opsz24'
                d='M86-860a13.568,13.568,0,0,1-5.452-1.105,14.114,14.114,0,0,1-4.439-3,14.337,14.337,0,0,1-3-4.445A13.5,13.5,0,0,1,72-874a13.567,13.567,0,0,1,1.105-5.452,14.115,14.115,0,0,1,3-4.439,14.338,14.338,0,0,1,4.445-3A13.5,13.5,0,0,1,86-888a13.567,13.567,0,0,1,5.452,1.105,14.116,14.116,0,0,1,4.439,3,14.337,14.337,0,0,1,3,4.445A13.5,13.5,0,0,1,100-874a13.567,13.567,0,0,1-1.105,5.452,14.116,14.116,0,0,1-3,4.439,14.337,14.337,0,0,1-4.445,3A13.5,13.5,0,0,1,86-860Zm-1.44-2.333v-2.882a2.85,2.85,0,0,1-2.076-.867,2.828,2.828,0,0,1-.875-2.084v-1.441l-7.069-7.069q-.1.669-.189,1.338A10.514,10.514,0,0,0,74.265-874a11.39,11.39,0,0,0,2.934,7.806A11.394,11.394,0,0,0,84.559-862.333Zm10.088-3.775a10.536,10.536,0,0,0,1.335-1.722,11.146,11.146,0,0,0,.961-1.939,12.534,12.534,0,0,0,.586-2.081,11.61,11.61,0,0,0,.206-2.188,11.76,11.76,0,0,0-1.977-6.638,11.024,11.024,0,0,0-5.366-4.289v.635a2.851,2.851,0,0,1-.867,2.077,2.829,2.829,0,0,1-2.084.875H84.559v2.951a1.384,1.384,0,0,1-.429,1.012,1.385,1.385,0,0,1-1.012.429H80.1v2.951h8.853a1.384,1.384,0,0,1,1.012.429,1.384,1.384,0,0,1,.429,1.012v4.5h1.5a2.833,2.833,0,0,1,1.723.551A2.812,2.812,0,0,1,94.647-866.108Z'
                transform='translate(-72 888)'
                fill='#fff'
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}

export default EarthIcon
